/**
 * ConnectMyHub — brand display helper.
 * Maps legacy internal "StaffHub" enum values (still stored in the database
 * for referential integrity) to their current customer-facing brand label.
 * Never rename the underlying DB values — only transform for display.
 */
export function brandify(s) {
  if (s == null) return s;
  return String(s).replace(/StaffHub/g, "ConnectMyHub");
}
